import React, { useRef } from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface CustomPickColorProps {
  id?: string;
  name?: string;
  label?: string;
  value: string;
  required?: boolean;
  readOnly?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  'data-testid'?: boolean | string;
}

const CustomPickColor: React.FC<CustomPickColorProps> = ({
  id,
  name,
  label,
  value,
  required,
  readOnly,
  onChange,
  'data-testid': dataTestId,
}) => {
  const theme = useTheme();
  const hiddenColorInput = useRef<HTMLInputElement>(null);

  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId
        ? `color-${name || id || 'picker'}`
        : undefined;

  const handleOpenColorPicker = () => {
    if (!readOnly && hiddenColorInput.current) {
      hiddenColorInput.current.click();
    }
  };

  return (
    <FormGroup controlId={id}>
      {label && (
        <FormLabel
          style={{ color: theme.colors.botaoConfirmar, fontWeight: 'bold' }}
          data-testid={testId ? `${testId}-label` : undefined}
        >
          {label}
          {required && (
            <span style={{ color: theme.colors.vermelho, marginLeft: 4 }}>
              *
            </span>
          )}
        </FormLabel>
      )}

      <div
        style={{
          display: 'flex',
          width: '100%',
          border: `1px solid ${theme.colors.bordaInput}`,
          borderRadius: '10px',
          overflow: 'hidden',
          height: '38px',
        }}
      >
        {/* Área do código */}
        <input
          type="text"
          value={value}
          readOnly
          data-testid={testId ? `${testId}-value` : undefined}
          style={{
            flex: 1,
            padding: '0 10px',
            border: 'none',
            backgroundColor: '#f7f7f7',
            fontSize: '15px',
            width: '100px',
          }}
        />

        <div
          style={{
            width: '60px',
            backgroundColor: value || '#ffffff',
            cursor: readOnly ? 'not-allowed' : 'pointer',
            position: 'relative',
          }}
        >
          {/* input color invisível, mas ocupando o bloco todo */}
          <input
            ref={hiddenColorInput}
            type="color"
            value={value || '#ffffff'}
            name={name}
            onChange={onChange}
            data-testid={dataTestId ? `${dataTestId}-picker` : undefined}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0,
              cursor: readOnly ? 'not-allowed' : 'pointer',
            }}
          />
        </div>
      </div>
    </FormGroup>
  );
};

export default CustomPickColor;
